"use client";

import React from "react";
import style from "./unionProducts.module.scss";
import { Products, ProductsUnion, ProductUnionType } from "@/common/entities/product/Product";
import ProductsUtils from "@/common/utils/ProductsUtils";
import { ImageWrapper } from "@/common/components/Images/ImageWrapper";
import { useRouter } from "next/navigation";

interface UnionProductVariantsProps {
    productUnions: ProductsUnion[];
    currentProduct: Products;
}

const UnionProductVariants = ({ productUnions, currentProduct }: UnionProductVariantsProps) => {
    const router = useRouter();

    if (!currentProduct) {
        return <></>;
    }

    if (!productUnions?.length) {
        return <></>;
    }
    const handleVariantClick = (e: React.MouseEvent, link: string) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });

        setTimeout(() => {
            router.push(link);
        }, 400);
    };

    const renderVariants = (productUnion: ProductsUnion) => {
        const variants = productUnion.unionProducts;
        if (variants.length === 0) return null;

        const selectedValue = variants.find((up) => up.product?.url === currentProduct.url)?.value || "";
        const isTextType = productUnion.type === ProductUnionType.text;

        return (
            <div className={`mb-2 ${isTextType ? "d-inline-block" : ""}`}>
                <div className={`${style.label} ${isTextType ? "d-inline-block" : ""}`}>
                    {productUnion.description}:<strong>{isTextType ? "" : selectedValue}</strong>
                </div>
                <div className={`${isTextType ? "d-inline" : "d-flex flex-wrap"} mb-3`}>
                    {variants
                        .sort((a, b) => a.position - b.position)
                        .map((unionProduct, index) => {
                            const linkedProduct = unionProduct.product;
                            const imageUrl = unionProduct.image ? unionProduct.image.originalFileName : linkedProduct?.defaultImage?.image.originalFileName;
                            const isSelected = linkedProduct?.url === currentProduct.url;
                            const link = ProductsUtils.getProductLink(linkedProduct.url, linkedProduct.categories) || "";

                            return (
                                <button
                                    type="button"
                                    className={`${style.variantItem} me-3 mb-3`}
                                    style={{
                                        border: isSelected ? "2px solid var(--primary-color)" : "1px solid #cacaca",
                                        cursor: "pointer",
                                        height: isTextType ? "40px" : "110px",
                                        width: isTextType ? "auto" : "80px",
                                        backgroundColor: "#fff",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        alignItems: isTextType ? "center" : "flex-start",
                                        justifyContent: "center",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                    }}
                                    title={unionProduct.value}
                                    onClick={(e) => handleVariantClick(e, link)}
                                    key={index}
                                >
                                    {productUnion.type === ProductUnionType.image && imageUrl ? (
                                        <>
                                            <ImageWrapper url={imageUrl} title={unionProduct.value} width={60} height={60} />
                                            <div
                                                className={style.variantImageText}
                                                style={{
                                                    fontWeight: isSelected ? "600" : "500",
                                                    fontSize: "10px",
                                                    color: isSelected ? "#000" : "#696969",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {unionProduct.value.length > 32 ? unionProduct.value.slice(0, 30) + ".." : unionProduct.value}
                                            </div>
                                        </>
                                    ) : (
                                        <span className="px-2 py-1">{unionProduct.value}</span>
                                    )}
                                </button>
                            );
                        })}
                </div>
            </div>
        );
    };

    return (
        <div className="mt-4">
            {productUnions
                .sort((a, b) => a.position - b.position)
                .map((productUnion, index) => (
                    <div key={index}>{renderVariants(productUnion)}</div>
                ))}
        </div>
    );
};

export default UnionProductVariants;
